import React from 'react';
import { Link } from 'react-router-dom';
import { FaAward, FaGem, FaBalanceScale, FaSyncAlt, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';
import './AboutUs.css';

const AboutUs = () => {
    return (
        <div className="about-container">
            {/* 1. Hero Banner Section */}
            <div className="about-hero">
                <div className="about-hero-overlay"></div>

                {/* 🚀 Developer / Web Services Contact Badge (Upper Right Corner) */}
                <div className="dev-credit-badge">
                    <div className="dev-badge-line1">
                        <span className="dev-pulse-dot"></span>
                        <span>For Developing + Hosting &amp; Maintainance of Website / WebApplication</span>
                    </div>
                    <div className="dev-badge-line2">
                        Contact : <strong>Shashi Sir</strong> on{' '}
                        <a href="tel:8709217624" className="dev-link" title="Call Shashi Sir">8709217624</a>{' '}
                        <a 
                            href="https://wa.me/918709217624?text=Hi%20Shashi%20Sir%2C%20I%20am%20interested%20in%20Website%2FWebApplication%20development%20and%20hosting." 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="dev-wa-link"
                            title="Chat on WhatsApp"
                        >
                            (call or whatsapp)
                        </a>{' '}
                        or Email us :{' '}
                        <a href="mailto:soft.shashi.kmr@gmail.com" className="dev-link" title="Send Email">soft.shashi.kmr@gmail.com</a>
                    </div>
                </div>

                <div className="about-hero-content">
                    <h5>HERITAGE & TRUST</h5>
                    <h1>Legacy Of Pure <br /><span>Gold & Elegance</span></h1>
                    <p>Crafting priceless moments and building timeless relationships since ______.</p>
                </div>
            </div>

            {/* 2. Our Story Section */}
            <div className="about-section story-section">
                <div className="about-grid">
                    <div className="story-text">
                        <span className="sub-heading">OUR JOURNEY</span>
                        <h2>The Story Behind Tiya Jewellers</h2>
                        <p>
                            Founded in ______ by <strong>Mr./Mrs. ______</strong>, Tiya Jewellers started with a simple vision: to bring purest gold, ethical diamond craftsmanship, and complete transparency to our valued customers in <strong>______</strong>.
                        </p>
                        <p>
                            Over the last ______ years, we have grown from a modest family shop to a leading jewellery destination. Every ornament in our collection tells a story of Indian tradition merged with contemporary designs, crafted specially for your weddings, festivals, and milestone celebrations.
                        </p>
                        <div className="founder-quote">
                            <p>"Jewellery isn't just an ornament; it's an emotion, a tradition, and a family legacy passed down through generations."</p>
                            <span>— Founder, Tiya Jewellers</span>
                        </div>
                    </div>
                    <div className="story-image-card">
                        <div className="image-placeholder">
                            <div className="placeholder-content">
                                <h3>TIYA JEWELLERS</h3>
                                <p>Showroom & Heritage Gallery</p>
                                <span>📍 ______, ______</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 3. Purity & Trust Pillars Section */}
            <div className="about-section pillars-section">
                <div className="section-header">
                    <span className="sub-heading">THE TIYA PROMISE</span>
                    <h2>Why Families Trust Us</h2>
                    <p>Our commitment to purity, honesty, and customer satisfaction sets us apart.</p>
                </div>

                <div className="pillars-grid">
                    <div className="pillar-card">
                        <div className="pillar-icon"><FaAward /></div>
                        <h3>100% BIS Hallmarked</h3>
                        <p>Every piece of gold jewellery carries the official Government BIS Hallmark (916 / 750) ensuring 100% purity guarantee.</p>
                    </div>

                    <div className="pillar-card">
                        <div className="pillar-icon"><FaGem /></div>
                        <h3>Certified Diamonds</h3>
                        <p>Our diamonds are certified by international grading laboratories (GIA / IGI / SGL) with complete clarity on the 4Cs.</p>
                    </div>

                    <div className="pillar-card">
                        <div className="pillar-icon"><FaBalanceScale /></div>
                        <h3>Transparent Billing</h3>
                        <p>No hidden charges! We provide a clear line-item breakup of metal weight, prevailing rate, making charges, and GST.</p>
                    </div>

                    <div className="pillar-card">
                        <div className="pillar-icon"><FaSyncAlt /></div>
                        <h3>Lifetime Buyback & Exchange</h3>
                        <p>Get maximum value and smooth, hassle-free policies whenever you exchange or upgrade your old gold jewellery with us.</p>
                    </div>
                </div>
            </div>

            {/* 4. Our Specialties & Collections */}
            <div className="about-section collections-preview-section">
                <div className="section-header">
                    <span className="sub-heading">EXQUISITE CRAFTSMANSHIP</span>
                    <h2>Our Signature Collections</h2>
                </div>

                <div className="collections-grid">
                    <div className="collection-card">
                        <div className="col-badge">Bridal</div>
                        <h3>Royal Heritage Bridal Wear</h3>
                        <p>Heavy bridal sets, Kundan, Polki, and antique gold jewellery for your big day.</p>
                    </div>

                    <div className="collection-card">
                        <div className="col-badge">Daily Wear</div>
                        <h3>Lightweight & Modern Gold</h3>
                        <p>Elegant chains, lightweight bangles, rings, and everyday office wear ornaments.</p>
                    </div>

                    <div className="collection-card">
                        <div className="col-badge">Diamonds</div>
                        <h3>Solitaire & Diamond Grace</h3>
                        <p>Timeless diamond necklaces, engagement rings, and studded luxury earrings.</p>
                    </div>

                    <div className="collection-card">
                        <div className="col-badge">Silverware</div>
                        <h3>Pure Silver & Utensils</h3>
                        <p>Pooja items, silver coins, payal, gift articles, and traditional silverware.</p>
                    </div>
                </div>
            </div>

            {/* 5. Showroom Info & Contact Footer Section */}
            <div className="about-section showroom-info-section">
                <div className="info-box">
                    <h2>Visit Our Experience Store</h2>
                    <p>Walk in to explore our wide range of exclusive designs or get expert consultation for custom jewellery.</p>

                    <div className="info-details-grid">
                        <div className="info-item">
                            <FaMapMarkerAlt className="info-icon" />
                            <div>
                                <h4>Showroom Address</h4>
                                <p>Tiya Jewellers, Main Road, ______, <br />______, ______ - ______</p>
                            </div>
                        </div>

                        <div className="info-item">
                            <FaPhoneAlt className="info-icon" />
                            <div>
                                <h4>Call / WhatsApp</h4>
                                <p>+91 ______ / +91 ______</p>
                            </div>
                        </div>

                        <div className="info-item">
                            <FaEnvelope className="info-icon" />
                            <div>
                                <h4>Email Us</h4>
                                <p>contact@tiyajewellers.com / ______@gmail.com</p>
                            </div>
                        </div>

                        <div className="info-item">
                            <FaClock className="info-icon" />
                            <div>
                                <h4>Store Timings</h4>
                                <p>Monday - Sunday: 10:30 AM to 08:30 PM <br />(Closed on: ______)</p>
                            </div>
                        </div>
                    </div>

                    <div className="info-cta">
                        <Link to="/collection" className="btn-about-cta">Explore Collection</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;